import { createFileRoute, useParams } from "@tanstack/react-router";
import { createAssetNotesListQueryOptions } from "@/features/notes/adapters/asset-notes-adapter";
import { AssetNotesWorkspace } from "@/features/notes/components/asset-notes-workspace";
import { NOTES_PAGE_SIZE } from "@/features/notes/types";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/assets/$assetId/workspace/notes",
)({
	loader: ({ context, params }) =>
		context.queryClient.ensureQueryData(
			createAssetNotesListQueryOptions({
				assetId: params.assetId,
				organizationId: params.orgId,
				start: 1,
				count: NOTES_PAGE_SIZE,
			}),
		),
	component: AssetWorkspaceNotesTab,
});

/**
 * Asset workspace Notes tab — thin route adapter.
 */
function AssetWorkspaceNotesTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/assets/$assetId/workspace/notes",
	});

	return <AssetNotesWorkspace orgId={params.orgId} assetId={params.assetId} />;
}
